import {
  GET_GENERATED_PASSWORD_RESPONSE,
  GET_PROVIDERS_RESPONSE,
  GET_PROVIDER_DETAILS_RESPONSE,
  GET_REQUEST_STATUS
} from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  providerDetails: null,
  generatedPassword: null,
  requestStatus: null
};

const providers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_PROVIDERS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_PROVIDER_DETAILS_RESPONSE:
      return {
        ...state,
        providerDetails: action.payload,
      };
    case GET_GENERATED_PASSWORD_RESPONSE:
      return {
        ...state,
        generatedPassword: action.payload,
      };
    case GET_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: action.payload === null ? null : action.payload,
      };
    default:
      return state;
  }
};

export default providers;
